// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2327": "bb4c22d14ded","3616": "2bd20f1d2224","5461": "4abfb4091f55",}[chunkId] + ".css"
}